import { AxiosResponse } from "axios";
import { showConsoleError } from "../util/ConsoleMessage";
import { Endpoint } from "./util/contants";
import { ImageResponse } from "./responsePayload/ImagesResponse";
import {
  apiGetRequest,
  apiDeleteRequest,
  apiPostMultiPartRequest,
} from "./util/apiUtils";

export const GetImages = async (
  endpoint: string | undefined = Endpoint.Image,
  brainId: number | undefined = undefined,
  page: number | undefined = undefined,
  pageSize: number | undefined = undefined
): Promise<ImageResponse | undefined> => {
  return await apiGetRequest<ImageResponse>(
    endpoint,
    {
      id: brainId,
    },
    {
      page: page,
      page_size: pageSize,
    }
  );
};

export const DeleteImage = async (
  id: number
): Promise<AxiosResponse | null> => {
  return await apiDeleteRequest(Endpoint.Image, { id: id });
};

export const UploadImageFormData = async (
  name: string,
  description: string,
  category: number,
  file: File
): Promise<AxiosResponse | null> => {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("description", description);
  formData.append("category", category.toString());
  formData.append("file", file);

  try {
    const response = await apiPostMultiPartRequest<AxiosResponse>(
      Endpoint.ImagePost,
      formData,
      {
        "Content-Type": "multipart/form-data",
      }
    );
    return response;
  } catch (error) {
    showConsoleError("Error uploading image with form data:", error);
    return null;
  }
};
